<div class="schedule-calendar bg-primary-white">
  <div class="p-2 pt-0 mb-1">
    <full-calendar
      #calendar
      [options]="calendarOptions"
      [events]="events()"
      class="bg-white p-0 py-3"
      [deepChangeDetection]="deepChangeDetection()"
    ></full-calendar>
    <div class="fs-5 px-2">
      <span class="fas fa-circle me-2 text-accent-orange"></span
      >{{ 'app.schedule.upcomingClass' | translate }}
    </div>
  </div>
</div>
